import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'clearButton']

  connect () {
    this.timeout = null

    // Close dropdown when clicking outside
    this.handleClickOutside = this.handleClickOutside.bind(this)
    document.addEventListener('click', this.handleClickOutside)

    // Show results on focus if there's already text
    this.handleFocus = this.handleFocus.bind(this)
    if (this.hasInputTarget) {
      this.inputTarget.addEventListener('focus', this.handleFocus)
    }
  }

  disconnect () {
    document.removeEventListener('click', this.handleClickOutside)
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    // Remove focus listener
    if (this.hasInputTarget) {
      this.inputTarget.removeEventListener('focus', this.handleFocus)
    }
  }

  handleFocus () {
    if (this.inputTarget.value.trim().length >= 2) {
      this.performSearch()
    }
  }

  handleClickOutside (event) {
    if (!this.element.contains(event.target)) {
      this.clearResults()
    }
  }

  handleKeydown (event) {
    if (event.key === 'Enter') {
      event.preventDefault()
      this.search()
    }
  }

  performSearch () {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    const query = this.inputTarget.value.trim()

    if (query.length < 2) {
      this.clearResults()
      return
    }

    this.timeout = setTimeout(() => {
      fetch(`/search?q=${encodeURIComponent(query)}`, {
        headers: {
          Accept: 'text/vnd.turbo-stream.html'
        }
      })
        .then(response => response.text())
        .then(html => {
          Turbo.renderStreamMessage(html)
        })
    }, 300) // 300ms debounce
  }

  search () {
    const query = this.inputTarget.value.trim()
    if (query) {
      window.location.href = `/search?q=${encodeURIComponent(query)}`
    }
  }

  clearResults () {
    const dropdown = document.getElementById('search_results_dropdown')
    if (dropdown) {
      dropdown.innerHTML = ''
    }
  }

  clearSearch () {
    this.inputTarget.value = ''
    this.toggleClearButton()
    this.performFullPageSearch()
  }

  toggleClearButton () {
    if (this.hasClearButtonTarget) {
      if (this.inputTarget.value.trim().length > 0) {
        this.clearButtonTarget.classList.remove('hidden')
      } else {
        this.clearButtonTarget.classList.add('hidden')
      }
    }
  }

  performFullPageSearch () {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    const query = this.inputTarget.value.trim()

    this.timeout = setTimeout(() => {
      // Update URL without page reload
      const url = new URL(window.location)
      if (query) {
        url.searchParams.set('q', query)
      } else {
        url.searchParams.delete('q')
      }
      window.history.replaceState({}, '', url)

      // Fetch results
      fetch(`/search?q=${encodeURIComponent(query)}&from=full_page`, {
        headers: {
          Accept: 'text/vnd.turbo-stream.html'
        }
      })
        .then(response => response.text())
        .then(html => {
          Turbo.renderStreamMessage(html)
        })
    }, 300) // 300ms debounce
  }
}
